module.exports = __webpack_public_path__ + "img/logo.0da53908.png";